var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.79 64.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ec6746;\n        stroke-miterlimit: 10;\n        stroke-width: 2.9px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.89,29.58c-5.03,0-9.1-4.07-9.1-9.1s4.08-9.1,9.1-9.1,9.1,4.07,9.1,9.1-4.08,9.1-9.1,9.1ZM20.89,1.45C10.15,1.45,1.45,10.16,1.45,20.89c0,8.72,12.81,30.27,17.64,38.07,1.12,1.81,1.81,2.88,1.81,2.88,0,0,.69-1.07,1.81-2.88,4.82-7.81,17.63-29.35,17.63-38.07C40.34,10.16,31.63,1.45,20.89,1.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrt);
export default __webpack_public_path__ + "static/media/Ort.b4b451fcdf21112596392701d880191a.svg";
export { ForwardRef as ReactComponent };